// extracted by mini-css-extract-plugin
module.exports = {"group_8":"countryResponse_group_8__L5HzJ","group_9":"countryResponse_group_9__3-bYq"};